import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_PLAID_LINK_TOKEN_QUERY = gql`
  query PlaidLinkToken($input: PlaidLinkTokenInput!) {
    plaidLinkToken(input: $input) {
      token
    }
  }
`;

export const UPDATE_PLAID_LINK_TOKEN_QUERY = gql`
  query UpdatePlaidLinkToken($input: UpdatePlaidLinkTokenInput!) {
    updatePlaidLinkToken(input: $input) {
      token
    }
  }
`;
